import { DesignerMeta_User } from '__generated__/DesignerMeta_User';
import { DesignerSource } from '__generated__/types';
import React from 'react';
import AddDesignerButton from './AddDesignerButton';
import DesignerMeta from './DesignerMeta';

interface Props {
    brief: {
        id: string;
        designers: DesignerMeta_User[];
        contacts: DesignerMeta_User[];
    };
}

const Contacts: React.FunctionComponent<Props> = ({ brief }) => {
    return (
        <>
            <div className="contacts-drawer__item-list">
                {brief.contacts.map(designer => (
                    <div className="contacts-drawer__item" key={designer.id}>
                        <div className="contacts-drawer__meta-wrapper">
                            <DesignerMeta designer={designer} hasFullStats={false} />
                            <div className="contacts-drawer__meta-wrapper__cta">
                                <AddDesignerButton
                                    designer={designer}
                                    designerSource={DesignerSource.CONTACT}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default Contacts;
